/** Matches Scit.Bff.Auth.BffAuthErrors — header on 401 responses. */
export const BFF_AUTH_ERROR_HEADER = 'X-BFF-Auth-Error';

/** BFF session expired or evicted from cache — client should re-handshake. */
export const BFF_AUTH_SESSION_NOT_FOUND = 'session_not_found';

/** Cached JWT past ValidTo — client should re-handshake. */
export const BFF_AUTH_TOKEN_EXPIRED = 'token_expired';

export const BFF_RECOVERABLE_AUTH_ERRORS = [
  BFF_AUTH_SESSION_NOT_FOUND,
  BFF_AUTH_TOKEN_EXPIRED,
] as const;
